import {Component, Input, OnInit} from '@angular/core';

interface ActionsListType {
  label: string;
  url: string;
  target: string;
}

@Component({
  selector: 'edsng-multi-action-card',
  templateUrl: './multi-action-card.component.html',
  styleUrls: ['./multi-action-card.component.css']
})
export class MultiActionCardComponent implements OnInit {

  @Input() labelHeader: string = '';
  @Input() imgSrc: string = null;
  @Input() description: string = null;
  @Input() titleDesc: string = null;
  @Input() background: string = null;
  @Input() actions: ActionsListType[] = [];
  constructor() { }

  ngOnInit() {
  }

}
